import * as z from "zod";

/**
 * Fetch an existing extension artifact's source + metadata so the editor can
 * seed itself when opening a step that already has an artifactId. Returns
 * null when the artifact doesn't exist for the caller's team (so the editor
 * can fall back to the starter snippet rather than throw).
 */
export const getExtensionArtifact = {
  name: "getExtensionArtifact" as const,
  input: z.object({ artifactId: z.string() }),
  output: z.object({
    artifact: z
      .object({
        contractId: z.string(),
        inputSelector: z.array(z.string()),
        code: z.string(),
      })
      .nullable(),
  }),
};
